import { render, staticRenderFns } from "./MeritsDemerits.vue?vue&type=template&id=9bf06d92&scoped=true"
import script from "./MeritsDemerits.vue?vue&type=script&lang=js"
export * from "./MeritsDemerits.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bf06d92",
  null
  
)

export default component.exports